import React from 'react';
import PropTypes from 'prop-types';
import { Input, Checkbox } from 'antd';
import isEqual from 'lodash/isEqual';

import ProfileAvatar from '../../../../../../../components/profileavatar';
import ModalFooter from '../../../../../../../components/modalfooter';

const { Search } = Input;

class ChooseMemberForm extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            search_key: "",
            filtered_agents: props.agents,
            selected_members: props.default_selected_members ? this.mapSelectedMembersWithIndex(props.default_selected_members) : {},
            indeterminate: props.default_selected_members && props.default_selected_members.length < props.agents.length,
            is_all_selected: props.default_selected_members && props.default_selected_members.length === props.agents.length,
        }
    }

    componentWillReceiveProps(nextProps) {
        const { search_text } = this.state;
        if (!isEqual(nextProps.agents, this.props.agents)) {
            const agents = [...nextProps.agents];
            if (search_text.trim().length !== 0) {
                this.setState({
                    filtered_agents: this.filterBySearchText(search_text, agents)
                });
            } else {
                this.setState({
                    filtered_agents: agents
                });
            }
        }
    }

    mapSelectedMembersWithIndex = members => {
        const { agents } = this.props;
        let selected_members = {};
        if (members.length > 0) {
            for (let i = 0; i < members.length; i++) {
                const index = agents.findIndex(agent => agent.email === members[i].email);
                if (index !== -1)
                    selected_members[index] = members[i];
            }
        }
        return selected_members;
    };

    filterBySearchText = (text, array) => {
        return array.filter(item => {
            return ((item.firstName && item.firstName !== undefined && item.firstName.toLowerCase().indexOf(text.toLowerCase()) !== -1) || (item.lastName && item.lastName !== undefined && item.lastName.toLowerCase().indexOf(text.toLowerCase()) !== -1) || (item.email && item.email !== undefined && item.email.toLowerCase().indexOf(text.toLowerCase()) !== -1));
        });
    };

    onChangeSearch = event => {
        const search_text = event.target.value;
        const { agents } = this.props;
        this.setState({ search_text });
        if (search_text.trim().length !== 0) {
            this.setState({
                filtered_agents: this.filterBySearchText(search_text, agents)
            });
        } else {
            this.setState({
                filtered_agents: agents
            });
        }
    };

    onChangeCheckbox = e => {
        const { agents } = this.props;
        const { selected_members } = this.state;

        if (e.target.checked) {
            const members = { ...selected_members, [e.target.index]: e.target.value };
            const total_selected_members = Object.keys(members).length;
            this.setState({
                selected_members: members,
                indeterminate: !!total_selected_members && agents.length > total_selected_members,
                is_all_selected: agents.length === total_selected_members,
            })
        } else {
            const members = { ...selected_members };
            delete members[e.target.index];
            const total_selected_members = Object.keys(members).length;
            this.setState({
                selected_members: members,
                indeterminate: !!total_selected_members && agents.length > total_selected_members,
                is_all_selected: false,
            })
        }
    };

    onChangeSelectAll = e => {
        const { agents } = this.props;
        this.setState({
            selected_members: e.target.checked ? Object.assign({}, agents) : {},
            indeterminate: false,
            is_all_selected: e.target.checked,
        })
    };

    onClickMemberSelectionConfirm = () => {
        const { selected_members } = this.state;
        this.props.handleOkClick(Object.values(selected_members));
    };

    renderMembersCheckboxList = () => {
        const { agents } = this.props;
        const { filtered_agents, selected_members } = this.state;
        if (filtered_agents && filtered_agents.length > 0) {
            return (
                filtered_agents.map((agent, index) => {
                    return (
                        <div key={index} className="ori-tb-pad-3 ori-flex-row">
                            <div className="ori-flex-column ori-flex-jc ori-r-mrgn-10">
                                <Checkbox index={index} value={agent} checked={selected_members[index] !== undefined} onChange={this.onChangeCheckbox} />
                            </div>
                            <ProfileAvatar title_class="ori-font-sm" shape="square" size="small" title={`${agent.firstName} ${agent.lastName}`} />
                            <div className="ori-loader-line-height ori-flex-column ori-flex-jc"> &nbsp; ({agent.email})</div>
                        </div>
                    );
                })
            );
        }
        if (agents && agents.length === 0) {
            return (<p className="ori-text-center ori-font-light ori-font-xs ori-font-danger">agent list is not avaliable. please reload the page to load agent list.</p>);
        }
        return (<p className="ori-text-center ori-font-light ori-font-xs">No match found</p>);
    };

    render() {
        const { handleCancelClick } = this.props;
        const { is_all_selected, indeterminate } = this.state;

        return (
            <div className="ori-lr-pad-15 ori-t-pad-15">
                <Search placeholder="search agents" className="ori-b-mrgn-15" onChange={this.onChangeSearch} />
                <div className="ori-tb-pad-10 ori-b-border-light">
                    <Checkbox indeterminate={indeterminate} checked={is_all_selected} onChange={this.onChangeSelectAll} >Select all</Checkbox>
                </div>
                <div className="ori-tb-pad-10">
                    {this.renderMembersCheckboxList()}
                </div>
                <div className="ori-absolute ori-full-width ori-align-bottom ori-align-left ori-b-pad-5">
                    <ModalFooter button_ok_text={"confirm"} handleCancelClick={handleCancelClick} handleOkClick={this.onClickMemberSelectionConfirm} capsule_button />
                </div>
            </div>
        );
    }
}

ChooseMemberForm.propTypes = {
    agents: PropTypes.array.isRequired,
    default_selected_members: PropTypes.array,
    handleCancelClick: PropTypes.func,
    handleOkClick: PropTypes.func,
};

ChooseMemberForm.defaultProps = {
    agents: [],
    default_selected_members: [],
};

export default ChooseMemberForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/members/groups/components/choosememberform/index.js